import barba from '@barba/core';
import * as THREE from 'three';



function siteIntroduction() {
    const urlParams = new URLSearchParams(window.location.search);
    const speedTestFlag = urlParams.get('speedtest');

    let container;

    let camera, scene, renderer;

    let group;

    let mouseX = 0, mouseY = 0;

    let windowHalfX = window.innerWidth / 2;
    let windowHalfY = window.innerHeight / 2;

    document.addEventListener( 'mousemove', onDocumentMouseMove, false );

    container = document.querySelector('.siteIntroduction__container');

    function init()
    {
        if (container != null)
        {
            container.id = "stage3d";

            camera = new THREE.PerspectiveCamera( 5, window.innerWidth / window.innerHeight, 1, 20000 );
            camera.position.z = 3000;

            scene = new THREE.Scene();
            scene.background = new THREE.Color( 0xFF5000 )

            var geometry = new THREE.SphereGeometry( 60, 60, 60 )
            var materials = [
                new THREE.MeshPhongMaterial({
                specular: '#00584B',
                color: '#00584B',
                emissive: '#00584B',
                shininess: 50 ,
                transparent: true,
                opacity: 1
            }),
                new THREE.MeshPhongMaterial({
                specular: '#EDABBB',
                color: '#EDABBB',
                emissive: '#EDABBB',
                shininess: 50 ,
                transparent: true,
                opacity: 1
            }),
                new THREE.MeshPhongMaterial({
                specular: '#FF5000',
                color: '#FF5000',
                emissive: '#FF5000',
                shininess: 50 ,
                transparent: true,
                opacity: 1
            })];

            group = new THREE.Object3D();

            for ( var i = 0; i < 400; i ++ )
            {
                var mesh = new THREE.Mesh( geometry, materials[Math.floor(Math.random() * materials.length)] );
                mesh.position.x = Math.random() * 1500 - 1000;
                mesh.position.y = Math.random() * 1500 - 1000;
                mesh.position.z = Math.random() * 1500 - 1000;
                mesh.rotation.x = Math.random() * 2 * Math.PI;
                mesh.rotation.y = Math.random() * 2 * Math.PI;
                mesh.opacity = 100;
                mesh.matrixAutoUpdate = false;
                mesh.updateMatrix();
                group.add( mesh );
            }

            scene.add( group );

            var directionalLight = new THREE.DirectionalLight(0xffffff);
            directionalLight.position.set(1, 1, 1).normalize();
            directionalLight.intensity = 0.2;
            scene.add(directionalLight);

            renderer = new THREE.WebGLRenderer();
            renderer.setSize( window.innerWidth, window.innerHeight );
            renderer.sortObjects = false;
            container.appendChild( renderer.domElement );

            window.addEventListener( 'resize', onWindowResize, false );
        }
    }


    function onWindowResize()
    {
        windowHalfX = window.innerWidth / 4;
        windowHalfY = window.innerHeight / 4;

        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();

        renderer.setSize( window.innerWidth, window.innerHeight );
    }


    function onDocumentMouseMove(event)
    {
        mouseX = ( event.clientX - windowHalfX ) / 2;
        mouseY = ( event.clientY - windowHalfY ) / 2;
    }


    const clock = new THREE.Clock();
    let previousTime = 0;

    const animate = () =>
    {
        if (container != null)
        {
            // const elapsedTime = clock.getElapsedTime();
            // const deltaTime = elapsedTime - previousTime;
            // previousTime = elapsedTime;

            // scene.traverse(function(obj) {

            //     if(obj.type === 'Mesh')
            //     {
            //         const posY = Math.sin(elapsedTime * 0.2) * 50;
            //         const posX = Math.sin(elapsedTime * 0.2) * 50;
            //         const posZ = Math.sin(elapsedTime * 0.2) * 50;

            //         obj.position.y += posY * deltaTime * 0.01;
            //         obj.position.x += posX * deltaTime * 0.01;
            //         obj.position.z += posZ * deltaTime * 0.01;
            //     }
            // });
            
            requestAnimationFrame( animate );
            render();
        }
    }


    function render()
    {
        camera.position.x += ( mouseX - camera.position.x ) * .0050;
        camera.position.y += ( - mouseY - camera.position.y ) * .0050;

        camera.lookAt( scene.position );

        var currentSeconds = Date.now();
        group.rotation.x = Math.sin( currentSeconds * 0.0003 ) * 0.25;
        group.rotation.y = Math.sin( currentSeconds * 0.0002 ) * 0.25;
        group.rotation.z = Math.sin( currentSeconds * 0.0001 ) * 0.25;

        renderer.render( scene, camera );
    }

    init();

    if (speedTestFlag === null)
    {
        animate();
    }
}


barba.hooks.enter((data) => {

    siteIntroduction();

});


siteIntroduction();